import $ from 'jquery';
import Plyr from 'plyr';
import MicroModal from 'micromodal';

import { FireComponent } from '@base';

export class PlyrVideo extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $video: this.$component.find('[data-plyr-video]'),
      $modal: this.$component.find('[data-plyr-modal]'),
      $modalTrigger: this.$component.find('.plyr__modal-trigger'),
      $videoInMmodal: this.$component.find('[data-plyr-modal] [data-plyr-video]'),
    };
  }

  _plyr() {
    let plyrVideo, plyrControls, muted, videoControls, autoplay, player;

    if (this.elements.$video.length && !this.elements.$modal.length) {
      plyrVideo = this.elements.$video;
      plyrControls = ['play'];
      muted = true;
      videoControls = false;
      autoplay = plyrVideo.get(0).dataset.autoplay;

      player = new Plyr(plyrVideo, {
        controls: plyrControls,
        ratio: '16:9',
        storage: {
          enabled: false,
        },
        muted: true,
        loop: {
          active: true,
        },
        youtube: {
          rel: 0,
          autoplay: autoplay === '1' ? 1 : 0,
          muted: muted ? 1 : 0,
          controls: videoControls ? 1 : 0,
        },
        vimeo: {
          autoplay: autoplay === '1' ? true : false,
          title: false,
          byline: false,
          portrait: false,
          speed: true,
          transparent: true,
          controls: videoControls,
          muted: muted,
        },
      });
    } else if (this.elements.$modal.length) {
      plyrVideo = this.elements.$videoInMmodal;
      plyrControls = ['play-large'];
      muted = false;
      videoControls = true;
      autoplay = 1;
      let self = this;

      this.elements.$modalTrigger.get(0).addEventListener('click', function () {
        let modalId = self.elements.$modal.get(0).getAttribute('id');
        MicroModal.show(modalId, {
          onShow: (modal) => {
            let videoProvider = self.elements.$video.get(0).getAttribute('data-plyr-provider');
            console.log(videoProvider);
            let modalContent = modal.querySelector('.modal__content');
            let videoClone = self.elements.$video.get(0).cloneNode();

            if (videoProvider !== 'echo360') {
              modalContent.appendChild(videoClone);
              let player = new Plyr(videoClone, {
                controls: plyrControls,
                ratio: '16:9',
                storage: {
                  enabled: false,
                },
                muted: true,
                loop: {
                  active: true,
                },
                youtube: {
                  rel: 0,
                  autoplay: autoplay === '1' ? 1 : 0,
                  muted: muted ? 1 : 0,
                  controls: videoControls ? 1 : 0,
                },
                vimeo: {
                  autoplay: autoplay === '1' ? true : false,
                  title: false,
                  byline: false,
                  portrait: false,
                  speed: true,
                  transparent: true,
                  controls: videoControls,
                  muted: muted,
                },
              });
              player.play();
              player.muted = false;
            } else {
              let echo360Url = self.elements.$video.get(0).getAttribute('data-plyr-embed-id');
              modalContent.innerHTML = `<iframe class="echo360-video modal__video" frameborder="0" width="100%" src="${echo360Url}"></iframe>`;
            }
          },
          onClose: (modal) => {
            let modalContent = modal.querySelector('.modal__content');
            modalContent.innerHTML = '';
          },
        });
      });
    }

    setTimeout(() => {
      $('.plyr__video-embed iframe').attr('tabindex', '-1');
    }, 500);
  }

  init() {
    if (this.componentExists) {
      this._plyr();
      MicroModal.init({
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: false,
        awaitCloseAnimation: false,
      });
    }
  }
}
